export default {
  name: 'mdi-v4',
  type: {
    positive: 'mdi-check-circle',
    negative: 'mdi-alert',
    info: 'mdi-information',
    warning: 'mdi-exclamation'
  },
  arrow: {
    up: 'mdi-arrow-up',
    right: 'mdi-arrow-right',
    down: 'mdi-arrow-down',
    left: 'mdi-arrow-left',
    dropdown: 'mdi-menu-down'
  },
  chevron: {
    left: 'mdi-chevron-left',
    right: 'mdi-chevron-right'
  },
  colorPicker: {
    spectrum: 'mdi-gradient',
    tune: 'mdi-tune',
    palette: 'mdi-palette-swatch'
  },
  pullToRefresh: {
    icon: 'mdi-refresh'
  },
  carousel: {
    left: 'mdi-chevron-left',
    right: 'mdi-chevron-right',
    up: 'mdi-chevron-up',
    down: 'mdi-chevron-down',
    navigationIcon: 'mdi-circle'
  },
  chip: {
    remove: 'mdi-close-circle',
    selected: 'mdi-check'
  },
  datetime: {
    arrowLeft: 'mdi-chevron-left',
    arrowRight: 'mdi-chevron-right',
    now: 'mdi-clock-outline',
    today: 'mdi-calendar-today'
  },
  editor: {
    bold: 'mdi-format-bold',
    italic: 'mdi-format-italic',
    strikethrough: 'mdi-format-strikethrough-variant',
    underline: 'mdi-format-underline',
    unorderedList: 'mdi-format-list-bulleted',
    orderedList: 'mdi-format-list-numbered',
    subscript: 'mdi-format-subscript',
    superscript: 'mdi-format-superscript',
    hyperlink: 'mdi-link',
    toggleFullscreen: 'mdi-fullscreen',
    quote: 'mdi-format-quote-close',
    left: 'mdi-format-align-left',
    center: 'mdi-format-align-center',
    right: 'mdi-format-align-right',
    justify: 'mdi-format-align-justify',
    print: 'mdi-printer',
    outdent: 'mdi-format-indent-decrease',
    indent: 'mdi-format-indent-increase',
    removeFormat: 'mdi-format-clear',
    formatting: 'mdi-format-color-text',
    fontSize: 'mdi-format-size',
    align: 'mdi-format-align-left',
    hr: 'mdi-minus',
    undo: 'mdi-undo',
    redo: 'mdi-redo',
    heading: 'mdi-format-size',
    heading1: 'mdi-format-header-1',
    heading2: 'mdi-format-header-2',
    heading3: 'mdi-format-header-3',
    heading4: 'mdi-format-header-4',
    heading5: 'mdi-format-header-5',
    heading6: 'mdi-format-header-6',
    code: 'mdi-code-tags',
    size: 'mdi-format-size',
    size1: 'mdi-numeric-1-box',
    size2: 'mdi-numeric-2-box',
    size3: 'mdi-numeric-3-box',
    size4: 'mdi-numeric-4-box',
    size5: 'mdi-numeric-5-box',
    size6: 'mdi-numeric-6-box',
    size7: 'mdi-numeric-7-box',
    font: 'mdi-format-font',
    viewSource: 'mdi-code-tags'
  },
  expansionItem: {
    icon: 'mdi-chevron-down',
    denseIcon: 'mdi-menu-down'
  },
  fab: {
    icon: 'mdi-plus',
    activeIcon: 'mdi-close'
  },
  field: {
    clear: 'mdi-close-circle',
    error: 'mdi-alert-circle'
  },
  pagination: {
    first: 'mdi-chevron-double-left',
    prev: 'mdi-chevron-left',
    next: 'mdi-chevron-right',
    last: 'mdi-chevron-double-right'
  },
  rating: {
    icon: 'mdi-star'
  },
  stepper: {
    done: 'mdi-check',
    active: 'mdi-pencil',
    error: 'mdi-alert'
  },
  tabs: {
    left: 'mdi-chevron-left',
    right: 'mdi-chevron-right',
    up: 'mdi-chevron-up',
    down: 'mdi-chevron-down'
  },
  table: {
    arrowUp: 'mdi-arrow-up',
    warning: 'mdi-alert',
    firstPage: 'mdi-chevron-double-left',
    prevPage: 'mdi-chevron-left',
    nextPage: 'mdi-chevron-right',
    lastPage: 'mdi-chevron-double-right'
  },
  tree: {
    icon: 'mdi-play'
  },
  uploader: {
    done: 'mdi-check',
    clear: 'mdi-close',
    add: 'mdi-plus-box',
    upload: 'mdi-cloud-upload',
    removeQueue: 'mdi-notification-clear-all',
    removeUploaded: 'mdi-check-all'
  }
}
